import {
    createSkyNetObjectRoutes,
} from 'app/shared-components/SkyNetObjectProfile/SkyNetObjectRoutes.utils'

import ServiceCentersDemoPage from './ServiceCentersDemoPage'
import domainConfig from './ServiceCentersDemo.config'

export default createSkyNetObjectRoutes(<ServiceCentersDemoPage />, domainConfig)
